export default "https://assets.egbcdn.net/assets/packs/_/images/cocktail/cocktail-liquid-449d71918682b81a3deae14845918ae1.png";